import { render } from "./ClientsAccountsPage.vue?vue&type=template&id=7a310cf2"
import script from "./ClientsAccountsPage.vue?vue&type=script&lang=js"
export * from "./ClientsAccountsPage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__